import { Navigate } from 'react-router-dom';
import { useGetLoggedInUserQuery } from '../redux/api/users';

interface Props {
	group: string;
	children: React.ReactNode;
}

export default function RequireGroup({ group, children }: Props) {
	const { data: user, isLoading } = useGetLoggedInUserQuery();

	if (isLoading) return null;

	if (!user?.groups?.includes(group)) {
		return <Navigate to="/" replace />;
	}

	return <>{children}</>;
}
